// extracted by mini-css-extract-plugin
export default {"formBodyStyle":"FormBody_formBodyStyle__HSA2t"};